import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { IAppState } from '../../store/interfaces/IAppState';
import { selectTenantNome } from '../../store/selectors';

@Component({
  selector: 'app-uniben-notification',
  templateUrl: './uniben-notification.component.html',
  styleUrls: ['./uniben-notification.component.scss'],
})
export class UnibenNotificationComponent {
  isUniben$ = this.store.select(selectTenantNome).pipe(map((tenantNome) => tenantNome === 'uniben'));
  closed = false;

  constructor(private store: Store<IAppState>) {}

  close(): void {
    this.closed = true;
  }
}
